/*
 * @Author: 刘洪壮 liuhongzhuang@nextmar.com
 * @Date: 2025-06-11 11:29:55
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-06-13 11:14:15
 * @FilePath: /src/components/Image/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
'use client';
import NextImage, { type ImageProps } from 'next/image';
import imageLoader from '@/utils/imageLoader';

import { useState } from 'react';
import { useImageSrc } from './useImageSrc';

type ImageRef =
  | React.RefObject<HTMLImageElement>
  | ((instance: HTMLImageElement | null) => void)
  | null
  | undefined;
const Image = ({
  src,
  errorComponent,
  ref,
  ...props
}: ImageProps & { errorComponent?: React.ReactNode; ref?: ImageRef }) => {
  const formatSrc = useImageSrc(src);
  const [isloadedError, setIsloadedError] = useState(false);

  // 如果处理后的src为null，直接返回null
  if (!formatSrc) {
    return null;
  }

  if (errorComponent) {
    return isloadedError ? (
      errorComponent
    ) : (
      <NextImage ref={ref} {...props} src={formatSrc} onError={() => setIsloadedError(true)} />
    );
  }

  return <NextImage ref={ref} {...props} src={formatSrc} loader={props.loader ?? imageLoader} />;
};

export default Image;
